import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import type { IconName } from "@frontend/components/atoms/Icon";

import { Heading } from "./Heading";
import { type HeadingDataProps, headingDataSchema } from "./Heading.schema";
import { HEADING_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [HEADING_TAG_NAME]: { props: HeadingDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-heading": HTMLElement;
  }
}

function RWCHeading({ icon, ...props }: HeadingDataProps): JSX.Element {
  return <Heading {...props} icon={icon as IconName | undefined} />;
}

componentManager.register(
  rwc(HEADING_TAG_NAME, {
    component: RWCHeading,
    dataSchema: headingDataSchema,
  }),
);
